import { ADMIN_ROUTES } from '~/constants/router'
import { lazyRetry } from '~/utils/lazyRetry'

import { adminRoles } from '~/modules/auth/conditions'

// Forms — submissions of the storefront's Form sections (Custom layout).
// Pantry-only page: there is no legacy equivalent, so the same component
// serves both slots.
const PantryForms = lazyRetry(() =>
  import('@pantry/features').then((m) => ({ default: m.FormsPage })),
)

const FormRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}/forms`,
    component: PantryForms,
    pantryComponent: PantryForms,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Forms',
  },
]

export default FormRouters
